import { metersToPixels } from '../constants.ts';
import { reachAxesFromMeters, reachIsDisk, type ReachAxes } from './reach.ts';

/** Reach, bow, and sprite size a seat plans and draws from. Equal axes stay a disk. */
export type PlanningFeel = {
  reach: ReachAxes | null;
  bowOffsetPx: number;
  movementRadius: number;
  lengthM: number;
  beamM: number;
};

export function planningFeelFromBoat(boat: {
  lengthM: number;
  beamM: number;
  turnM: number;
  accelM: number;
  brakeM: number;
}): PlanningFeel {
  const axes = reachAxesFromMeters(boat.turnM, boat.accelM, boat.brakeM);
  const disk = reachIsDisk(axes);

  return {
    reach: disk ? null : axes,
    bowOffsetPx: metersToPixels(boat.lengthM / 2),
    movementRadius: disk ? axes.turn : Math.max(axes.turn, axes.accel, axes.brake),
    lengthM: boat.lengthM,
    beamM: boat.beamM,
  };
}
